module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-container"
  }, [_c('div', {
    staticClass: "loader"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "loaderLines",
    staticClass: "loader__lines"
  }, [_c('div', {
    staticClass: "loader__thin-line"
  }), _vm._v(" "), _c('div', {
    ref: "loaderBigLine",
    staticClass: "loader__big-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "loader__state"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.loadingState) + "%\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader__text"
  }, [_c('img', {
    attrs: {
      "src": "/assets/imgs/loading.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e13a904!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Loader/Loader.vue
// module id = 277
// module chunks = 0